import { Module } from '@models/module.model'
import {
	Box,
	Button,
	Checkbox,
	Collapse,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { RoleInfo } from '@models/role.model'
import { Control, useFormContext } from 'react-hook-form'

function Row({
	control,
	row,
	permissions,
	setPermissions,
}: {
	control: Control<RoleInfo, any>
	row: Module
	permissions: string[]
	setPermissions: React.Dispatch<React.SetStateAction<string[]>>
}) {
	const [open, setOpen] = React.useState(false)
	const codes = row.module_rights_list.map((x) => x.code)

	return (
		<React.Fragment>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell width={'50px'}>
					<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>

				<TableCell width={'50px'}>
					<Checkbox
						onChange={(e) => {
							if (e.target.checked) {
								setPermissions([...permissions, ...codes])
							} else {
								setPermissions(permissions.filter((x) => !codes.includes(x)))
							}
						}}
						checked={permissions.filter((x) => codes.includes(x)).length === codes.length}
						indeterminate={
							permissions.filter((x) => codes.includes(x)).length !== codes.length &&
							permissions.filter((x) => codes.includes(x)).length > 0
						}
					/>
				</TableCell>
				<TableCell>{row.display_name}</TableCell>
			</TableRow>

			<TableRow>
				<TableCell colSpan={3}>
					<Collapse in={open} timeout="auto" unmountOnExit sx={{ paddingLeft: '70px' }}>
						{row.module_rights_list?.map((mr) => (
							<TableRow key={mr.code}>
								<TableCell></TableCell>
								<TableCell>
									<Checkbox
										onChange={(e) => {
											if (e.target.checked) {
												setPermissions([...permissions, mr.code])
											} else {
												setPermissions(permissions.filter((x) => x !== mr.code))
											}
										}}
										checked={permissions.includes(mr.code)}
									/>
								</TableCell>
								<TableCell>{mr.display_name}</TableCell>
							</TableRow>
						))}
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	)
}

export function ModuleAccessConfigDialog({
	control,
	moduleList,
	opened,
	close,
}: {
	control: Control<RoleInfo, any>
	moduleList: Module[]
	opened: boolean
	close: () => void
}) {
	const { t } = useTranslation()
	const { setValue, getValues } = useFormContext<RoleInfo>()
	const [permissions, setPermissions] = useState<string[]>([])
	let modulePermissions: string[] = []
	moduleList.forEach((m) => {
		m.module_rights_list.forEach((mr) => {
			modulePermissions.push(mr.code)
		})
	})

	useEffect(() => {
		setPermissions(getValues('originalPermissions') || [])
	}, [getValues('originalPermissions')])

	return (
		<Dialog open={opened} onClose={close} maxWidth="sm" fullWidth>
			<DialogTitle>{t('Configurate application permissions')}</DialogTitle>
			<DialogContent>
				<Box>
					<TableContainer component={Paper}>
						<Table aria-label="collapsible table">
							<TableHead>
								<TableRow>
									<TableCell />
									<TableCell>
										<Checkbox
											onChange={(e) => {
												if (e.target.checked) {
													setPermissions([...permissions, ...modulePermissions])
												} else {
													setPermissions(permissions.filter((x) => !modulePermissions.includes(x)))
												}
											}}
											checked={
												permissions.filter((x) => modulePermissions.includes(x)).length ===
												modulePermissions.length
											}
											indeterminate={
												permissions.filter((x) => modulePermissions.includes(x)).length !==
													modulePermissions.length &&
												permissions.filter((x) => modulePermissions.includes(x)).length > 0
											}
										/>
									</TableCell>
									<TableCell>{t('Permissions')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{moduleList.map((row) => (
									<Row
										control={control}
										key={row.id}
										row={row}
										permissions={permissions}
										setPermissions={setPermissions}
									/>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					color="success"
					style={{
						background: 'green',
					}}
					onClick={() => {
						if (getValues('id')) {
							// diff
							let diff: {
								permission_code: string
								active: boolean
								exists: boolean
							}[] = []
							const oldPermissions = getValues('originalPermissions') || []
							oldPermissions.forEach((x) => {
								if (!permissions.includes(x)) {
									diff.push({
										permission_code: x,
										active: false,
										exists: false,
									})
								} else {
									diff.push({
										permission_code: x,
										active: true,
										exists: true,
									})
								}
							})

							permissions
								.filter((n) => !diff.map((z) => z.permission_code).includes(n))
								.forEach((x) => {
									diff.push({
										permission_code: x,
										active: true,
										exists: false,
									})
								})
							setValue('permissionsDiff', diff, {
								shouldDirty: true,
							})
						} else
							setValue('permissions', permissions, {
								shouldDirty: true,
							})

						close()
					}}
				>
					{t('Save')}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
